import './styles.css';

export const ChartOrMessage = ({
  data,
  children,
  message = 'No data available',
  q,
}) => {
  const hasDataCheckins =
    Array.isArray(data) &&
    data.some(
      (item) =>
        item.checkins ||
        item.impairments ||
        item.totalCheckins ||
        item.y ||
        item.impaired,
    );

  if (!hasDataCheckins) {
    return (
      <div className='noDataContainer'>
        <p className='noDataText'>{message}</p>
      </div>
    );
  }

  return children;
};
